import { FormattedMessage } from 'react-intl';
import {
  AlphabeticalKey,
  getProviderPrefix,
  ProviderViewSetGroup,
} from '../../../utilities/provider-view-set';
import { GradientList } from '../../../components/molecules/GradientList/GradientList';
import { Caption } from '../../../components/atoms/Text/Text';
import { useConnectedProviders } from '../../../banking/components/multibanking/multibankingUtils';
import { messages } from '../ProvidersList/messages';
import { PartlyHighlightedText } from '../ProvidersList/PartlyHighlightedText';
import { EmptyResult, ProvidersListWrapper } from '../ProvidersList/ProvidersList.styles';
import { isProviderConnected } from '../ProvidersList/ProvidersList';
import {
  LetterBox,
  LetterCircle,
  LetterGroupContainer,
  LetterProviders,
  ListItem,
  StyledButton,
} from './BranchList.styles';

type ProviderItemProps = {
  title: string;
  onClick: () => void;
  connected?: boolean;
  currentSearchQuery?: string;
};

export const ProviderItem = ({
  title,
  onClick,
  connected,
  currentSearchQuery = '',
}: ProviderItemProps) => {
  return (
    <ListItem>
      <StyledButton
        disabled={connected}
        onClick={() => onClick()}
        data-testid={title}
        data-test="providerListItem"
      >
        <Caption as="span">
          <PartlyHighlightedText
            text={title}
            textToHighlight={currentSearchQuery}
            providerPrefix={getProviderPrefix(title)}
          />
        </Caption>
      </StyledButton>
    </ListItem>
  );
};

export type SelectProviderViewSetGroup = (payload: {
  providerViewSetGroup: ProviderViewSetGroup;
}) => void;

export type BranchListProps = {
  providerViewSetGroups: [AlphabeticalKey, ProviderViewSetGroup[]][];
  onProviderItemClick: SelectProviderViewSetGroup;
  currentSearchQuery?: string;
};

export const BranchList = ({
  providerViewSetGroups,
  onProviderItemClick,
  currentSearchQuery = '',
}: BranchListProps) => {
  const connectedProviders = useConnectedProviders();

  if (providerViewSetGroups.length === 0) {
    return (
      <EmptyResult>
        <FormattedMessage {...messages.noProviders} />
      </EmptyResult>
    );
  }

  return (
    <ProvidersListWrapper data-testid="branch-list">
      <GradientList>
        {providerViewSetGroups.map(([key, providerSetGroups]) => {
          return (
            <LetterGroupContainer key={key}>
              <LetterBox>
                <span translate="no">
                  <LetterCircle>{key}</LetterCircle>
                </span>
              </LetterBox>
              <LetterProviders columnCount={providerSetGroups.length === 1 ? 1 : 2}>
                {providerSetGroups.map((setGroup) => (
                  <ProviderItem
                    currentSearchQuery={currentSearchQuery}
                    connected={isProviderConnected(connectedProviders, setGroup.providers)}
                    title={setGroup.title}
                    key={setGroup.title}
                    onClick={() => onProviderItemClick({ providerViewSetGroup: setGroup })}
                  />
                ))}
              </LetterProviders>
            </LetterGroupContainer>
          );
        })}
      </GradientList>
    </ProvidersListWrapper>
  );
};
